module.exports = __webpack_public_path__ + "img/carousel_0.5a423530.jpg";